import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import ActionTypes from '../../constants/ActionTypes';
import common from '../_common/actions';
import Select from '../Select';
var updateStore = common.updateStore(Select.components.getSubstate, ActionTypes.COMPONENTS); // ============ creators ===========

function update(component, data) {
  return function (dispatch) {
    dispatch(actionUpdate(component, data));
  };
}
/**
 * Remove whole component state or if path is defined, remove just everything on path.
 * @param {string} component Component property from state.components
 * @param {string} path Dot separated path or "" or null. If path is not defined whole component will be removed.
 * @returns
 */


function remove(component, path) {
  return actionRemove(component, path);
} // ============ actions ===========


function actionUpdate(component, data) {
  return {
    type: ActionTypes.COMPONENTS.UPDATE,
    component: component,
    update: data
  };
}

function actionSet(component, path, value) {
  return {
    type: ActionTypes.COMPONENTS.SET,
    component: component,
    path: path,
    value: value
  };
}

function actionRemove(component, path) {
  return _objectSpread({
    type: ActionTypes.COMPONENTS.REMOVE,
    component: component
  }, path ? {
    path: path
  } : {});
} // ============ export ===========


export default {
  update: update,
  updateStateFromView: updateStore,
  updateStore: updateStore,
  set: actionSet,
  remove: remove
};